import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import messages from 'src/pages/TutorialDetailsPage/messages';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

type DeleteQuestionOptionProps = {
  tutorialUuid: string;
  questionUuid: string;
  optionUuid: string;
};

const deleteQuestionOption = async ({
  tutorialUuid,
  questionUuid,
  optionUuid,
}: DeleteQuestionOptionProps) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteQuestionOption({
      tutorialUuid,
      questionUuid,
      optionUuid,
    }),
  );
  return data;
};

export const useDeleteQuestionOption = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteQuestionOption,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialOptionDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};
